/** Fired after pricelist loadPage has populated redux (schools, centres, etc.). */
export const PRICELIST_PAGE_READY = 'pricelist-page-ready';

export const notifyPricelistPageReady = (): void => {
  window.dispatchEvent(new Event(PRICELIST_PAGE_READY));
};
